import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import AppBar from '../../components/appBar/AppBar';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('appBarBloc');
  const [menu, setMenu] = useState({
    routes: [],
    userMenu: [],
  });
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState();

  useEffect(() => {
    const menuSub = blocRef.current.menu$.subscribe(setMenu);
    const logoUrlSub = blocRef.current.logoUrl$.subscribe(setLogoUrl);

    return () => {
      menuSub.unsubscribe();
      logoUrlSub.unsubscribe();
    };
  }, []);

  const handleNavigation = (route) => history.push(route);
  const handleLogout = () => {
    blocRef.current.logout();
    history.push('/');
  };

  const handleLogoClick = () => {
    if (menu?.logoPath) {
      history.push(menu.logoPath);
      return;
    }
    history.push('/');
  };

  const handleChatClick = () => {
    blocRef.current.openFreshchatDialog();
  };

  return <AppBar logoUrl={logoUrl} onLogoClick={handleLogoClick} onLogout={handleLogout} onNavigation={handleNavigation} onChatClick={handleChatClick} menu={menu} />;
};
